import { PortfolioAccountManagerAdminModel } from '../shared/models/portfolio-account-manager-admin-model';
import { PortfolioListRecordModel } from '../shared/models/portfolio-list-record-model';
import { PortfolioAccountManagerModel } from '../shared/models/portfolio-account-manager-model';
import { PortfolioAddModel } from '../shared/models/portfolio-add-model';
import { ApplicationMessageSource } from '../../core/models/application-message-source';
import { MessageType } from '../../core/models/enum/message-type';
import { ApplicationMessage } from '../../core/models/application-message';
import { PortfolioService } from '../shared/services/portfolio.service';
import { CustomMessageService } from '../../core/message.service';
import {
  IPromise,
  IValidator,
  MessageLevel,
  Validator,
} from '../../shared/validation/validators';
import { ValidationUtils } from '../../shared/validation/validation-runner';
import { FieldState } from '../../shared/models/field-state';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { LookupService } from '../../shared/services/lookup.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hr-portfolio-add',
  templateUrl: './portfolio-add.component.html',
  styleUrls: ['./portfolio-add.component.less'],
  standalone: false,
})
export class PortfolioAddComponent implements OnInit {
  constructor(
    private lookupService: LookupService,
    private messageService: CustomMessageService,
    private translationService: TranslateService,
    private portfolioService: PortfolioService
  ) {
    this.accountManagers = [];
    this.portfolioSubmitData = new PortfolioAddModel();
  }

  @Output()
  public onAdd: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  public onClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  public onUpdate: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  public display: boolean;

  public portfolioSubmitData: PortfolioAddModel;
  public accountManagers: PortfolioAccountManagerAdminModel[];

  public fieldStates: {
    name: FieldState;
    comment: FieldState;
    accountManager: FieldState;
  };

  public get field() {
    return this.fieldStates;
  }

  ngOnInit() {
    let lookupData = this.lookupService.getCachedLookupData();
    this.initObject();
    this.accountManagers = null;
  }

  public loadDropDown() {
    this.accountManagers = null;
    this.portfolioService.accountManagerList().subscribe((a) => {
      this.accountManagers = a.items;
    });
  }
  public onAddPortfolioClick() {
    this.loadDropDown();
    this.onAdd.emit(true);
  }

  public onCloseClick() {
    this.initObject();
    this.onClose.emit(false);
  }

  public onCreatePortfolio() {
    let portfolio = this.portfolioSubmitData;
    let validators = this.getValidators();
    this.invokeValidation(validators, () => {
      this.portfolioService.createPortfolio(portfolio).subscribe(() => {
        this.messageService.pushMessage(<ApplicationMessage>{
          type: MessageType.Success,
          sourceId: ApplicationMessageSource.global,
          summary: '',
          detail: this.translationService.instant('message.SaveMessage'),
        });
      });
      this.onUpdate.emit();
      this.onCloseClick();
    });
  }

  public initObject() {
    this.portfolioSubmitData.name = null;
    this.portfolioSubmitData.comment = null;
    this.portfolioSubmitData.accountManagerId = null;
    this.initializeFieldsState();
  }

  public initializeFieldsState() {
    this.fieldStates = {
      name: new FieldState(() => this.portfolioSubmitData.name),
      comment: new FieldState(() => this.portfolioSubmitData.comment),
      accountManager: new FieldState(
        () => this.portfolioSubmitData.accountManagerId && this.accountManagers
      ),
    };
  }

  public invokeValidation(validators: IValidator[], onValid?: () => void) {
    ValidationUtils.invokeValidation(
      validators,
      this.getFieldStatesObject(),
      onValid
    );
  }

  private getFieldStatesObject(): { [index: string]: FieldState } {
    let result: { [index: string]: FieldState } = {};
    for (let p in this.fieldStates) {
      if (this.fieldStates.hasOwnProperty(p)) {
        result[this.fieldStates[p].fieldId] = this.fieldStates[p];
      }
    }
    return result;
  }

  private getValidators() {
    let portfolio = this.portfolioSubmitData;
    let field = this.field;

    let emptyMessage = this.translationService.instant(
      'message.ValueLeftEmpty'
    );
    let incorrectFormat = this.translationService.instant(
      'message.IncorrectFormat'
    );
    let isAlreadyInUse = this.translationService.instant(
      'message.IsAlreadyInUse'
    );

    return [
      Validator.forRequired(field.name, () => portfolio.name, emptyMessage),
      this.display
        ? Validator.forAsync(
            field.name,
            () => {
              var p = this.portfolioService.validatePortfolioName(
                portfolio.name
              );
              return <IPromise>{
                catch: (error) => p.catch(error),
                then: (data) => p.then(data),
                finally: () => {
                  alert('todo');
                },
              };
            },
            (response: any) => {
              var isValid = response.isSuccess;
              return {
                message: isValid ? null : isAlreadyInUse,
                level: isValid ? null : MessageLevel.Error,
                isValid: isValid,
              };
            }
          )
        : Validator.forBypass(field.name),
      Validator.forRequired(
        field.accountManager,
        () => portfolio.accountManagerId && this.accountManagers,
        emptyMessage
      ),
      Validator.forNotRequired(field.comment, () => portfolio.comment),
    ];
  }
}
